// eslint-disable-next-line disable-autofix/import/no-namespace
import * as icons from "./equation-icons";
import React from "react";

export const MathEquationMenu = {
  teacherPortalIBPYPRootNodes: [
    "Chemistry",
    "BASIC",
    "ADVANCE",
    "SETS_MATRICES",
    "GREEK",
    "ENGLISH",
  ],

  chemistry_right_nodes: [
    "plus",
    "1",
    "2",
    "3",
    "backspace",
    "minus",
    "4",
    "5",
    "6",
    "undo",
    "positive_ions",
    "7",
    "8",
    "9",
    "redo",
    "negative_ions",
    "single_bond",
    "double_bond",
    "0",
    "forwardSlash",
    "decimal",
    "triple_bond",
    "blank",
    "insert",
  ],

  nodes: [
    {
      id: "CHEMISTRY",
      label: "Chemistry",
      children: [
        "blank",
        "systemic_difference",
        "degree",
        "left_subscript_superscript",
        "right_subscript_superscript",
        "infinity",
        "open_square_bracket",
        "close_square_bracket",
        "open_parenthesis",
        "close_parenthesis",

        "mol",
        "molK",
        "left_superscript",
        "right_superscript",
        "subscript",
        "solid_state",
        "backward_reaction",
        "reversible_reaction",
        "equilibrium",
        "forward_reaction",

        "kj",
        "kj_mol",
        "additional_compound",
        "left_right_subscript_superscript",
        "liquid_state",
        "backward_reaction_with_overscript",
        "reversible_reaction_with_overscript",
        "equilibrium_reaction_with_overscript",
        "forward_reaction_with_overscript",

        "js",
        "kj_mol_inverse",
        "gas",
        "gas_state",
        "backward_reaction_with_underscript",
        "reversible_reaction_with_underscript",
        "equilibrium_reaction_with_underscript",
        "forward_reaction_with_underscript",

        "blank",
        "blank",
        "blank",
        "blank",
        "precipitate",
        "aqueous_state",
        "backward_reaction_with_overscript_underscript",
        "reversible_reaction_with_overscript_underscript",
        "equilibrium_reaction_with_overscript_underscript",
        "forward_reaction_with_overscript_underscript",
      ],
    },
    {
      id: "BASIC",
      label: "Basic",
      children: [
        "fraction",
        "natural_log",
        "log",
        "log_base",
        "i_inv",
        "sum",
        "sub",
        "sup",
        "open_parenthesis",
        "close_parenthesis",

        "absolute",
        "imaginary",
        "e",
        "pi",
        "plus_minus",
        "minus_plus",
        "ratio",
        "percent",
        "open_square_brace",
        "close_square_brace",

        "sine",
        "cos",
        "tan",
        "theta",
        "deg",
        "ang",
        "arrow",
        "double_arrow",
        "open_brace",
        "close_brace",

        "sec",
        "cosec",
        "cot",
        "gcd",
        "arg",
        "im",
        "re",
        "ten_power_x",
        "neg",
        "complex_conjugate",

        "piecewise",
        "infinity",
        "nthroot",
        "square_root",
        "cube_root",
        "greater_than_equals",
        "less_than_equals",
        "greater_than_1",
        "less_than_1",
      ],
    },
    {
      id: "ADVANCE",
      label: "Advance",
      children: [
        "eop",
        "natural_log",
        "log",
        "log_base",
        "i_inv",
        "sum",
        "sub",
        "sup",
        "open_parenthesis",
        "close_parenthesis",

        "vector_icon",
        "complex_conjugate",
        "langrange_first_derivative",
        "lagrange_second_derivative",
        "tends_to",
        "limit",
        "probability",
        "permutation",
        "combination",
        "factorial",

        "blank",
        "blank",
        "newton_first_derivative",
        "newton_second_derivative",
        "derivation",
        "leibniz_first_derivative",
        "conditional_probability",
        "permutation_with_repetition",
        "combination_with_repetition",
        "binomial_coefficient",

        "blank",
        "blank",
        "evaluation_function",
        "integral",
        "contour_integral",
        "leibniz_second_derivative",
        "leibniz_nth_derivative",
        "ceiling",
        "floor",
        "function",

        "vector",
        "change_in",
        "infinity",
        "nthroot",
        "square_root",
        "cube_root",
        "greater_than_equals",
        "less_than_equals",
        "greater_than_1",
        "less_than_1",
      ],
    },
    {
      id: "SETS_MATRICES",
      label: "Sets and Matrices",
      children: [
        "evaluation_function",
        "natural_log",
        "log",
        "log_base",
        "i_inv",
        "sum",
        "sub",
        "sup",
        "open_parenthesis",
        "close_parenthesis",

        "matrix",
        "matrix3x3",
        "matrix3x1",
        "not_subset",
        "subset",
        "intersection",
        "union",
        "there_exists",
        "set_builder",
        "literal_set",

        "matrix_element",
        "determinant_matrix",
        "integer",
        "not_superset_of",
        "superset",
        "conjugate",
        "open_interval",
        "closed_interval",
        "empty_set",
        "power_set",

        "real_number",
        "natural_number",
        "rational_number",
        "strict_subset",
        "strict_superset",
        "contains",
        "right_half_open_interval",
        "left_half_open_interval",
        "not_element_of",
        "element_of",

        "transpose",
        "hermitian_conjugate",
        "infinity",
        "nthroot",
        "square_root",
        "cube_root",
        "greater_than_equals",
        "less_than_equals",
        "greater_than_1",
        "less_than_1",
      ],
    },
    {
      id: "GREEK",
      label: "Greek Alphabets",
      children: [
        "blank",
        "natural_log",
        "log",
        "log_base",
        "i_inv",
        "sum",
        "sub",
        "sup",
        "open_parenthesis",
        "close_parenthesis",

        "blank",
        "blank",
        "alpha",
        "beta",
        "gamma",
        "delta",
        "epsilon",
        "Zeta",
        "eta",
        "theta",

        "blank",
        "blank",
        "iota",
        "Kappa",
        "Lambda",
        "mu",
        "nu",
        "xi",
        "pi",
        "rho",

        "blank",
        "blank",
        "shift",
        "Sigma",
        "tau",
        "Upsilon",
        "Phi",
        "Chi",
        "Psi",
        "Omega",

        "blank",
        "blank",
        "infinity",
        "nthroot",
        "square_root",
        "cube_root",
        "greater_than_equals",
        "less_than_equals",
        "greater_than_1",
        "less_than_1",
      ],
    },
    {
      id: "ENGLISH",
      label: "English Alphabets",
      children: [
        "blank",
        "natural_log",
        "log",
        "log_base",
        "i_inv",
        "sum",
        "sub",
        "sup",
        "open_parenthesis",
        "close_parenthesis",

        "q",
        "w",
        "E",
        "r",
        "t",
        "y",
        "u",
        "i",
        "o",
        "p",

        "blank",
        "a",
        "s",
        "d",
        "f",
        "g",
        "h",
        "j",
        "k",
        "l",

        "blank",
        "blank",
        "shift",
        "z",
        "x",
        "c",
        "v",
        "b",
        "n",
        "m",

        "blank",
        "blank",
        "infinity",
        "nthroot",
        "square_root",
        "cube_root",
        "greater_than_equals",
        "less_than_equals",
        "greater_than_1",
        "less_than_1",
      ],
    },
  ],

  nodeChildren: [
    // ! CHEMISTRY nodeChildren
    {
      id: "systemic_difference",
      latex: "\\Delta",
      text: "Systemic difference",
      variant: "plain-subtle",
      icon: icons.SystemicDifference,
    },
    {
      id: "degree",
      latex: "{\\placeholder}\\degree",
      text: "Degree",
      variant: "plain-subtle",
      icon: icons.Degree,
    },
    {
      id: "subscript",
      latex: "#0_{\\placeholder}",
      text: "Subscript",
      variant: "plain-subtle",
      icon: icons.Subscript,
    },
    {
      id: "right_superscript",
      latex: "#0^{\\placeholder}",
      text: "Right Superscript",
      variant: "plain-subtle",
      icon: icons.Superscript,
    },
    {
      id: "left_superscript",
      latex: "^{\\placeholder{}}\\placeholder{}",
      text: "Left Superscript",
      variant: "plain-subtle",
      icon: icons.SuperscriptLeft,
    },
    {
      id: "open_square_bracket",
      latex: "\\left[#0\\right]",
      text: "Open square bracket",
      variant: "plain-subtle",
      icon: icons.SquareBrackets,
    },
    {
      id: "close_square_bracket",
      latex: "]",
      text: "Close square bracket",
      variant: "plain-subtle",
      icon: icons.SquareBrackets1,
    },
    {
      id: "mol",
      latex: "mol",
      text: "mol",
      variant: "plain-subtle",
      icon: icons.Mol,
    },
    {
      id: "molK",
      latex: "molK",
      text: "molK",
      variant: "plain-subtle",
      icon: icons.MolK,
      style: { width: "100%", justifyContent: "center" },
    },
    {
      id: "left_subscript_superscript",
      latex: "^{\\placeholder{}}_{\\placeholder{}}\\placeholder{}",
      text: "Left subscript and superscript",
      variant: "plain-subtle",
      icon: icons.LeftSubscriptAndSuperscript,
    },
    {
      id: "right_subscript_superscript",
      latex: "\\placeholder{}^{\\placeholder{}}_{\\placeholder{}}",
      text: "Right subscript and superscript",
      variant: "plain-subtle",
      icon: icons.RightSubscriptAndSuperscript,
    },
    {
      id: "solid_state",
      latex: "(s)",
      text: "Solid state",
      variant: "plain-subtle",
      icon: icons.SolidState,
    },
    {
      id: "backward_reaction",
      latex: "\\longleftarrow",
      text: "Backward reaction",
      variant: "plain-subtle",
      icon: icons.BackwardReaction,
    },
    {
      id: "reversible_reaction",
      latex: "\\rightleftarrows",
      text: "Reversible reaction",
      variant: "plain-subtle",
      icon: icons.ReversibleReaction,
    },
    {
      id: "equilibrium",
      latex: "\\rightleftharpoons",
      text: "Equilibrium",
      variant: "plain-subtle",
      icon: icons.Equilibrium,
    },
    {
      id: "forward_reaction",
      latex: "\\longrightarrow",
      text: "Forward reaction",
      variant: "plain-subtle",
      icon: icons.ForwardReaction,
    },
    {
      id: "kj",
      latex: "kJ",
      text: "kJ",
      variant: "plain-subtle",
      icon: icons.KJ,
    },
    {
      id: "kj_mol",
      latex: "kJ/mol",
      text: "kJ/mol",
      variant: "plain-subtle",
      icon: icons.KJmol,
      style: { gridColumn: "span 2", width: "100%", justifyContent: "center" },
    },
    {
      id: "additional_compound",
      latex: "{\\placeholder}\\centerdot{\\placeholder}",
      text: "Additional compound",
      variant: "plain-subtle",
      icon: icons.AdditionalCompound,
    },
    {
      id: "left_right_subscript_superscript",
      latex:
        "^{\\placeholder{}}_{\\placeholder{}}\\placeholder{}^{\\placeholder{}}_{\\placeholder{}}",
      text: "Left right subscript superscript",
      variant: "plain-subtle",
      icon: icons.LeftAndRightSubscriptAndSuperscript,
    },
    {
      id: "liquid_state",
      latex: "(l)",
      text: "Liquid state",
      variant: "plain-subtle",
      icon: icons.LiquidState,
    },
    {
      id: "backward_reaction_with_overscript",
      latex: "\\xleftarrow{\\placeholder}",
      text: "Backward reaction with overscript",
      variant: "plain-subtle",
      icon: icons.BackwardReactionWithOverScript,
    },
    {
      id: "reversible_reaction_with_overscript",
      latex: "\\overset{\\placeholder{}}{\\rightleftarrows}",
      text: "Reversible reaction with overscript",
      variant: "plain-subtle",
      icon: icons.ReversibleReactionWithOverScript,
    },
    {
      id: "equilibrium_reaction_with_overscript",
      latex: "\\overset{\\placeholder{}}{\\rightleftharpoons}",
      text: "Equilibrium reaction with overscript",
      variant: "plain-subtle",
      icon: icons.EquilibriumWithOverScript,
    },
    {
      id: "forward_reaction_with_overscript",
      latex: "\\xrightarrow{\\placeholder}",
      text: "Forward reaction with overscript",
      variant: "plain-subtle",
      icon: icons.ForwardReactionWithOverScript,
    },
    {
      id: "js",
      latex: "J.s",
      text: "J.s",
      variant: "plain-subtle",
      icon: icons.Js,
    },
    {
      id: "kj_mol_inverse",
      latex: "kJ/{{mol^{-1}}",
      text: (
        <>
          {"kJ/mol"}
          <sup>-1</sup>
        </>
      ),
      variant: "plain-subtle",
      icon: icons.KJPerMolInverse,
      style: { gridColumn: "span 3", width: "100%", justifyContent: "center" },
    },
    {
      id: "gas",
      latex: "\\uparrow",
      text: "Gas",
      variant: "plain-subtle",
      icon: icons.Gas,
    },
    {
      id: "gas_state",
      latex: "(g)",
      text: "Gas state",
      variant: "plain-subtle",
      icon: icons.GasState,
    },
    {
      id: "backward_reaction_with_underscript",
      latex: "\\xleftarrow[\\placeholder{}]{\\;}",
      text: "Backward reaction with underscript",
      variant: "plain-subtle",
      icon: icons.BackwardReactionWithUnderScript,
    },
    {
      id: "reversible_reaction_with_underscript",
      latex: "\\underset{\\placeholder{}}{\\rightleftarrows}",
      text: "Reversible reaction with underscript",
      variant: "plain-subtle",
      icon: icons.ReversibleReactionWithUnderScript,
    },
    {
      id: "equilibrium_reaction_with_underscript",
      latex: "\\underset{\\placeholder{}}{\\rightleftharpoons}",
      text: "Equilibrium reaction with underscript",
      variant: "plain-subtle",
      icon: icons.EquilibriumWithUnderScript,
    },
    {
      id: "forward_reaction_with_underscript",
      latex: "\\xrightarrow[\\placeholder{}]{}",
      text: "Forward reaction with underscript",
      variant: "plain-subtle",
      icon: icons.ForwardReactionWithUnderScript,
    },
    {
      id: "precipitate",
      latex: "\\downarrow",
      text: "Precipitate",
      variant: "plain-subtle",
      icon: icons.Precipitate,
    },
    {
      id: "aqueous_state",
      latex: "(aq)",
      text: "Aqueous state",
      variant: "plain-subtle",
      icon: icons.AqueousState,
    },
    {
      id: "backward_reaction_with_overscript_underscript",
      latex: "\\xleftarrow[\\placeholder{}]{\\placeholder{}}",
      text: "Backward reaction with overscript and underscript",
      variant: "plain-subtle",
      icon: icons.BackwardReactionWithOverAndUnderScript,
    },
    {
      id: "reversible_reaction_with_overscript_underscript",
      latex:
        "\\overset{\\placeholder{}}{\\underset{\\placeholder{}}{\\rightleftarrows}}",
      text: "Reversible reaction with overscript and underscript",
      variant: "plain-subtle",
      icon: icons.ReversibleReactionWithOverAndUnderScript,
    },
    {
      id: "equilibrium_reaction_with_overscript_underscript",
      latex:
        "\\overset{\\placeholder{}}{\\underset{\\placeholder{}}{\\rightleftharpoons}}",
      text: "Equilibrium reaction with overscript and underscript",
      variant: "plain-subtle",
      icon: icons.EquilibriumWithOverAndUnderScript,
    },
    {
      id: "forward_reaction_with_overscript_underscript",
      latex: "\\xrightarrow[\\placeholder{}]{\\placeholder{}}",
      text: "Forward reaction with overscript and underscript",
      variant: "plain-subtle",
      icon: icons.ForwardReactionWithOverAndUnderScript,
    },
    {
      id: "positive_ions",
      latex: "{\\placeholder}^+",
      text: "Positive ion",
      variant: "plain-subtle",
      icon: icons.PositiveIons,
    },
    {
      id: "negative_ions",
      latex: "{\\placeholder}^-",
      text: "Negative ion",
      variant: "plain-subtle",
      icon: icons.NegativeIons,
    },
    {
      id: "single_bond",
      latex: "-",
      text: "Single bond",
      variant: "plain-subtle",
      icon: icons.SingleBond,
    },
    {
      id: "double_bond",
      latex: "=",
      text: "Double bond",
      variant: "plain-subtle",
      icon: icons.DoubleBond,
    },
    {
      id: "decimal",
      latex: ".",
      text: "Decimal",
      variant: "plain-subtle",
      icon: icons.Decimal,
    },
    {
      id: "triple_bond",
      latex: "{\\ce{#}}",
      text: "Triple bond",
      variant: "plain-subtle",
      icon: icons.TrippleBond,
    },
    {
      id: "plus",
      text: "Plus",
      latex: "+",
      variant: "plain-default",
      icon: icons.Addition,
    },

    // ! BASIC nodeChildren
    {
      id: "fraction",
      latex: "\\frac{#0}{\\placeholder}",
      text: "Fraction",
      variant: "plain-subtle",
      icon: icons.Fraction,
    },
    {
      id: "natural_log",
      latex: "\\ln",
      text: "Natural log",
      variant: "plain-default",
      icon: icons.NaturalLogarithm,
    },
    {
      id: "log_base",
      latex: "\\log_#0",
      text: "Log with base",
      variant: "plain-default",
      icon: icons.LogarithmicBase,
    },
    {
      id: "log",
      latex: "\\log",
      text: "Log",
      variant: "plain-default",
      icon: icons.Logarithm,
    },
    {
      id: "i_inv",
      latex: "{\\placeholder}^{-1}",
      text: "Inverse",
      variant: "plain-default",
      icon: icons.Inverse,
    },
    {
      id: "sum",
      latex: "\\sum_{\\placeholder{}}^{\\placeholder{}}\\placeholder{}",
      text: "Summation",
      variant: "plain-default",
      icon: icons.Summation,
    },
    {
      id: "sub",
      latex: "#0_{\\placeholder}",
      text: "Subscript (_)",
      variant: "plain-default",
      icon: icons.Subscript,
    },
    {
      id: "sup",
      latex: "#0^{\\placeholder}",
      text: "Superscript (^)",
      variant: "plain-default",
      icon: icons.Superscript,
    },
    {
      id: "open_parenthesis",
      latex: "\\left(#0\\right)",
      text: "Open parenthesis",
      variant: "plain-default",
      icon: icons.Parentheses,
    },
    {
      id: "close_parenthesis",
      latex: ")",
      text: "Close parenthesis",
      variant: "plain-default",
      icon: icons.Parentheses1,
    },
    {
      id: "absolute",
      latex: "\\left|\\placeholder{}\\right|",
      text: "Absolute",
      variant: "plain-subtle",
      icon: icons.Absolute,
    },
    {
      id: "imaginary",
      latex: "\\imaginaryI",
      text: "Imaginary unit",
      variant: "plain-subtle",
      icon: icons.ImaginaryUnit,
    },
    {
      id: "e",
      latex: "\\exponentialE",
      text: "Exponential e",
      variant: "plain-subtle",
      icon: icons.NaturalLogarithmicBase,
    },
    {
      id: "pi",
      latex: "\\pi",
      text: "Pi",
      variant: "plain-subtle",
      icon: icons.Pi,
      shiftLatex: "\\Pi",
      shiftIcon: icons.CapitalPi,
    },
    {
      id: "plus_minus",
      latex: "\\pm",
      text: "Plus minus",
      variant: "plain-subtle",
      icon: icons.PlusMinus,
    },
    {
      id: "minus_plus",
      latex: "\\mp",
      text: "Minus plus",
      variant: "plain-subtle",
      icon: icons.MinusPlus,
    },
    {
      id: "ratio",
      latex: "\\colon",
      text: "Colon",
      variant: "plain-subtle",
      icon: icons.Ratio,
    },
    {
      id: "percent",
      latex: "\\%",
      text: "Percent",
      variant: "plain-subtle",
      icon: icons.Percent,
    },
    {
      id: "open_square_brace",
      latex: "\\left[#0\\right]",
      text: "Open square bracket",
      variant: "plain-subtle",
      icon: icons.SquareBrackets,
    },
    {
      id: "close_square_brace",
      latex: "]",
      text: "Close square bracket",
      variant: "plain-subtle",
      icon: icons.SquareBrackets1,
    },

    {
      id: "min",
      latex: "\\min",
      text: "Minimum",
      variant: "plain-subtle",
      icon: icons.MinimumOf,
    },
    {
      id: "max",
      latex: "\\max",
      text: "Maximum",
      variant: "plain-subtle",
      icon: icons.MaximumOf,
    },
    {
      id: "lcm",
      latex: "lcm",
      text: "LCM",
      variant: "plain-subtle",
      icon: icons.LeastCommonMultiple,
    },
    {
      id: "gcd",
      latex: "gcd",
      text: "GCD",
      variant: "plain-subtle",
      icon: icons.GreatestCommonDivisor,
    },
    {
      id: "deg",
      latex: "{\\placeholder}\\degree",
      text: "Degree",
      variant: "plain-subtle",
      icon: icons.Degree,
    },
    {
      id: "ang",
      latex: "\\angle{\\placeholder}",
      text: "Angle",
      variant: "plain-subtle",
      icon: icons.Angle,
    },
    {
      id: "arrow",
      latex: "\\Rightarrow",
      text: "Implies",
      variant: "plain-subtle",
      icon: icons.Implies,
    },
    {
      id: "double_arrow",
      latex: "\\Leftrightarrow",
      text: "Equivalent",
      variant: "plain-subtle",
      icon: icons.Equivalent,
    },
    {
      id: "open_brace",
      latex: "\\left\\lbrace#0\\right\\rbrace",
      text: "Open brace",
      variant: "plain-subtle",
      icon: icons.CurlyBrackets,
    },
    {
      id: "close_brace",
      latex: "\\rbrace",
      text: "Close brace",
      variant: "plain-subtle",
      icon: icons.CurlyBrackets1,
    },
    {
      id: "arg",
      latex: "\\arg",
      text: "Argument of",
      variant: "plain-subtle",
      icon: icons.ArgumentOf,
    },
    {
      id: "im",
      latex: "Im",
      text: "Imaginary",
      variant: "plain-subtle",
      icon: icons.ImaginaryPart,
    },
    {
      id: "re",
      latex: "Re",
      text: "Real",
      variant: "plain-subtle",
      icon: icons.RealPart,
    },
    {
      id: "ten_power_x",
      latex: "10^\\placeholder{}",
      text: "ten power x",
      variant: "plain-subtle",
      icon: icons.TenPowerX,
    },
    {
      id: "neg",
      latex: "\\neg",
      text: "Negation",
      variant: "plain-subtle",
      icon: icons.Negation,
    },
    {
      id: "for_all",
      latex: "\\forall",
      text: "For all",
      variant: "plain-subtle",
      icon: icons.ForAll,
    },
    {
      id: "disjunction",
      latex: "\\vee",
      text: "Disjunction",
      variant: "plain-subtle",
      icon: icons.Disjunction,
    },
    {
      id: "conjugate",
      latex: "\\wedge",
      text: "Conjugate",
      variant: "plain-subtle",
      icon: icons.Conjugate,
    },
    {
      id: "proportional",
      latex: "\\varpropto",
      text: "Proportional",
      variant: "plain-subtle",
      icon: icons.Proportional,
    },
    {
      id: "less_than",
      latex: "\\lt",
      text: "Less than",
      variant: "plain-subtle",
      icon: icons.LesserThan,
    },
    {
      id: "greater_than",
      latex: "\\gt",
      text: "Greater than",
      variant: "plain-subtle",
      icon: icons.GreaterThan,
    },

    {
      id: "piecewise",
      latex:
        "\\begin{cases} {\\placeholder{}} & \\text{if} \\, {\\placeholder{}} \\\\ {\\placeholder{}} & \\text{if} \\, {\\placeholder{}} \\end{cases}",
      text: "Piecewise function",
      variant: "plain-subtle",
      icon: icons.PiecewiseFunction,
      style: { gridColumn: "span 2", width: "100%", justifyContent: "center" },
    },
    {
      id: "change_in",
      latex: "\\Delta",
      text: "Systemic difference",
      variant: "plain-subtle",
      icon: icons.CapitalDelta,
    },
    {
      id: "infinity",
      latex: "\\infty",
      text: "Infinity",
      variant: "plain-default",
      icon: icons.Infinity,
    },
    {
      id: "square_root",
      latex: "\\sqrt{\\placeholder}",
      text: "Square root",
      variant: "plain-default",
      icon: icons.SqaureRoot,
    },
    {
      id: "cube_root",
      latex: "\\sqrt[3]{\\placeholder}",
      text: "Cube root",
      variant: "plain-default",
      icon: icons.CubeRoot,
    },
    {
      id: "nthroot",
      latex: "\\sqrt[#0]{\\placeholder}",
      text: "nth root",
      variant: "plain-default",
      icon: icons.NthRoot,
    },
    {
      id: "less_than_equals",
      latex: "\\leq",
      text: "Less than or equal to",
      variant: "plain-default",
      icon: icons.LesserThanOrEqualTo,
    },
    {
      id: "greater_than_equals",
      latex: "\\geq",
      text: "Greater than or equal to",
      variant: "plain-default",
      icon: icons.GreaterThanOrEqualTo,
    },
    {
      id: "less_than_1",
      latex: "\\lt",
      text: "Less than",
      variant: "plain-default",
      icon: icons.LesserThan,
    },
    {
      id: "greater_than_1",
      latex: "\\gt",
      text: "Greater than",
      variant: "plain-default",
      icon: icons.GreaterThan,
    },
    {
      id: "blank",
      variant: "plain-default",
    },

    // ! ADVANCE nodeChildren

    {
      id: "evaluation_function",
      text: "Evaluation function",
      latex: "\\placeholder{}\\Big|^\\placeholder{}_\\placeholder{}",
      variant: "plain-subtle",
      icon: icons.EvaluateFunction,
    },
    {
      id: "langrange_first_derivative",
      text: "Langrange first derivative",
      latex: "{\\placeholder{}}^{\\prime}",
      variant: "plain-subtle",
      icon: icons.Lagrange1StDerivative,
    },
    {
      id: "lagrange_second_derivative",
      text: "Lagrange second derivative",
      latex: "{\\placeholder{}}^{\\prime\\prime}",
      variant: "plain-subtle",
      icon: icons.Lagrange2NdDerivative,
    },
    {
      id: "tends_to",
      text: "Tends to",
      latex: "\\rightarrow",
      variant: "plain-subtle",
      icon: icons.TendsTo,
    },
    {
      id: "limit",
      text: "Limit",
      latex: "\\lim_{\\placeholder{} \\to \\placeholder{}} \\, #0",
      variant: "plain-subtle",
      icon: icons.Limit,
    },
    {
      id: "probability",
      text: "Probability",
      latex: "\\textmd{Pr}\\left(#0\\right)",
      variant: "plain-subtle",
      icon: icons.Probability,
    },
    {
      id: "permutation",
      text: "Permutation",
      latex: "_\\placeholder{}\\textbf{P}_#0",
      variant: "plain-subtle",
      icon: icons.Permutations,
    },
    {
      id: "combination",
      text: "Combination",
      latex: "_\\placeholder{}\\textbf{C}_#0",
      variant: "plain-subtle",
      icon: icons.Combinations,
    },
    {
      id: "factorial",
      text: "Factorial",
      latex: "!",
      variant: "plain-subtle",
      icon: icons.Factorial,
    },
    {
      id: "sine",
      text: "Sine",
      latex: "\\sin",
      variant: "plain-subtle",
      icon: icons.Sin,
    },
    {
      id: "sec",
      text: "Sec",
      latex: "\\sec",
      variant: "plain-subtle",
      icon: icons.Sec,
    },

    {
      id: "newton_first_derivative",
      text: "Newton first derivative",
      latex: "\\dot{\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.Newton1StDerivative,
    },
    {
      id: "newton_second_derivative",
      text: "Newton second derivative",
      latex: "\\ddot{\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.Newton2NdDerivative,
    },
    {
      id: "derivation",
      text: "Derivation",
      latex: "\\frac{\\mathrm{d}y}{\\mathrm{d}x}",
      variant: "plain-subtle",
      icon: icons.Derivation,
    },
    {
      id: "leibniz_first_derivative",
      text: "Leibniz first derivative",
      latex:
        "\\frac{\\differentialD \\placeholder{}}{\\differentialD \\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.Leibniz1StDerivative,
    },
    {
      id: "conditional_probability",
      text: "Conditional probability",
      latex: "\\textmd{Pr}\\left(\\placeholder{}|\\placeholder{}\\right)",
      variant: "plain-subtle",
      icon: icons.ConditionalProbability,
    },
    {
      id: "permutation_with_repetition",
      text: "Permutation with repetition",
      latex: "_\\placeholder{}^R\\textbf{P}_#0",
      variant: "plain-subtle",
      icon: icons.PermutationsWithRepetitions,
    },
    {
      id: "combination_with_repetition",
      text: "Combination with repetition",
      latex: "_\\placeholder{}^R\\textbf{C}_#0",
      variant: "plain-subtle",
      icon: icons.CombinationsWithRepetitions,
    },
    {
      id: "binomial_coefficient",
      text: "Binomial coefficient",
      latex: "\\binom{\\placeholder{}} {\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.BinomialCoefficient,
    },
    {
      id: "cos",
      text: "Cosine",
      latex: "\\cos",
      variant: "plain-subtle",
      icon: icons.Cos,
    },
    {
      id: "cosec",
      text: "Cosec",
      latex: "\\cosec",
      variant: "plain-subtle",
      icon: icons.Cosec,
    },

    {
      id: "floor",
      text: "Floor",
      latex: "\\lfloor{\\placeholder{}}\\rfloor",
      variant: "plain-subtle",
      icon: icons.Ceiling,
    },
    {
      id: "ceiling",
      text: "Ceiling",
      latex: "\\lceil{\\placeholder{}}\\rceil",
      variant: "plain-subtle",
      icon: icons.Floor,
    },
    {
      id: "leibniz_nth_derivative",
      text: "Leibniz nth derivative",
      latex:
        "\\frac{\\differentialD^\\placeholder{}\\placeholder{}}{\\differentialD \\placeholder{}^\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.LeibnizNthDerivative,
    },
    {
      id: "leibniz_second_derivative",
      text: "Leibniz second derivative",
      latex:
        "\\frac{\\differentialD^2\\placeholder{}}{\\differentialD \\placeholder{}^2}",
      variant: "plain-subtle",
      icon: icons.Leibniz2NdDerivative,
    },
    {
      id: "integral",
      text: "Integral",
      latex: "\\int_{\\placeholder{}}^{\\placeholder{}} #0 \\,d\\placeholder{}",
      variant: "plain-subtle",
      icon: icons.IntegralValues,
    },
    {
      id: "contour_integral",
      text: "Contour Integral",
      latex: "\\oint{\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.Integral,
    },
    {
      id: "function",
      text: "Function",
      latex: "f(#0)",
      variant: "plain-subtle",
      icon: icons.Function,
    },
    {
      id: "theta",
      text: "Theta",
      latex: "\\theta",
      variant: "plain-subtle",
      icon: icons.Theta,
      shiftLatex: "\\Theta",
      shiftIcon: icons.CapitalTheta,
    },
    {
      id: "tan",
      text: "Tan",
      latex: "\\tan",
      variant: "plain-subtle",
      icon: icons.Tan,
    },
    {
      id: "cot",
      text: "Cot",
      latex: "\\cot",
      variant: "plain-subtle",
      icon: icons.Cot,
    },
    {
      id: "eop",
      latex: "\\blacksquare",
      text: "End of proof",
      variant: "plain-subtle",
      icon: icons.EndOfProof,
    },
    {
      id: "vector_icon",
      text: "Vector",
      latex: "\\overrightarrow{\\placeholder{}}",
      variant: "plain-subtle",
      icon: icons.VectorIcon,
    },
    {
      id: "vector",
      text: "3*1 Vector/Matrix",
      latex:
        "\\begin{pmatrix}{\\placeholder{}}\\\\ {\\placeholder{}}\\\\ {\\placeholder{}}\\end{pmatrix}",
      variant: "plain-subtle",
      icon: icons.Vector,
    },
    {
      id: "complex_conjugate",
      text: "Complex conjugate",
      latex: "\\bar{\\placeholder}",
      variant: "plain-subtle",
      icon: icons.ComplexConjugate,
    },

    // ! SETS_MATRICES nodeChildren

    {
      id: "matrix",
      text: "Matrix",
      latex:
        "\\begin{bmatrix} {\\placeholder{}} & {\\placeholder{}} \\\\ {\\placeholder{}} & {\\placeholder{}} \\end{bmatrix}",
      variant: "plain-subtle",
      icon: icons.Matrix,
    },
    {
      id: "matrix3x3",
      text: "Matrix 3x3",
      latex:
        "\\begin{bmatrix} {\\placeholder{}} & {\\placeholder{}} & {\\placeholder{}} \\\\ {\\placeholder{}} & {\\placeholder{}} & {\\placeholder{}} \\\\ {\\placeholder{}} & {\\placeholder{}} & {\\placeholder{}} \\end{bmatrix}",
      variant: "plain-subtle",
      icon: icons.Matrix3X3,
    },
    {
      id: "matrix3x1",
      text: "Matrix 3x1",
      latex:
        "\\begin{bmatrix} {\\placeholder{}} \\\\ {\\placeholder{}} \\\\ {\\placeholder{}} \\end{bmatrix}",
      variant: "plain-subtle",
      icon: icons.Matrix3X1,
    },
    {
      id: "natural_number",
      text: "Natural number",
      latex: "\\mathbf{N}",
      variant: "plain-subtle",
      icon: icons.NaturalNumbers,
    },
    {
      id: "not_subset",
      text: "Not subset",
      latex: "\\nsubset",
      variant: "plain-subtle",
      icon: icons.NotASubset,
    },
    {
      id: "subset",
      text: "Subset",
      latex: "\\subseteq",
      variant: "plain-subtle",
      icon: icons.Subset,
    },
    {
      id: "intersection",
      text: "Intersection",
      latex: "\\cap",
      variant: "plain-subtle",
      icon: icons.Intersection,
    },
    {
      id: "union",
      text: "Union",
      latex: "\\cup",
      variant: "plain-subtle",
      icon: icons.Union,
    },
    {
      id: "there_exists",
      text: "There exists",
      latex: "\\exists",
      variant: "plain-subtle",
      icon: icons.ThereExists,
    },
    {
      id: "set_builder",
      text: "Set builder",
      latex: "\\left\\lbrace\\placeholder{}|\\placeholder{}\\right\\rbrace",
      variant: "plain-subtle",
      icon: icons.SetBuilder,
    },
    {
      id: "literal_set",
      text: "Literal set",
      latex: "\\left\\lbrace\\placeholder{}\\right\\rbrace}",
      variant: "plain-subtle",
      icon: icons.LiteralSet,
    },

    {
      id: "determinant_matrix",
      text: "Determinant matrix",
      latex:
        "\\begin{vmatrix} {\\placeholder{}} & {\\placeholder{}} & {\\placeholder{}} \\\\ {\\placeholder{}} & {\\placeholder{}} & {\\placeholder{}} \\end{vmatrix}",
      variant: "plain-subtle",
      icon: icons.DeterminantMatrix,
    },
    {
      id: "integer",
      text: "Integer",
      latex: "\\mathbf{Z}",
      variant: "plain-subtle",
      icon: icons.Integers,
    },
    {
      id: "not_superset_of",
      text: "Not superset",
      latex: "\\nsupset",
      variant: "plain-subtle",
      icon: icons.NotASuperset,
    },
    {
      id: "superset",
      text: "Superset",
      latex: "\\supseteq",
      variant: "plain-subtle",
      icon: icons.NotASubset1,
    },
    {
      id: "open_interval",
      text: "Open interval",
      latex: "\\left(#0,\\placeholder{}\\right)",
      variant: "plain-subtle",
      icon: icons.OpenInterval,
    },
    {
      id: "closed_interval",
      text: "Close interval",
      latex: "\\left[#0,\\placeholder{}\\right]",
      variant: "plain-subtle",
      icon: icons.CloseInterval,
    },
    {
      id: "empty_set",
      text: "Empty set",
      latex: "\\emptyset",
      variant: "plain-subtle",
      icon: icons.EmptySet,
    },
    {
      id: "power_set",
      text: "Power set",
      latex: "\\mathbf{P}\\left(#0\\right)",
      variant: "plain-subtle",
      icon: icons.PowerSet,
    },

    {
      id: "matrix_element",
      text: "Matrix element",
      latex:
        "\\begin{bmatrix} {\\placeholder{}} \\end{bmatrix}_{{\\placeholder{}}{\\placeholder{}}}",
      variant: "plain-subtle",
      icon: icons.MatrixElement,
    },
    {
      id: "rational_number",
      text: "Rational number",
      latex: "\\mathbf{Q}",
      variant: "plain-subtle",
      icon: icons.RationalNumbers,
    },
    {
      id: "strict_subset",
      text: "Strict subset",
      latex: "\\subset",
      variant: "plain-subtle",
      icon: icons.StrictSubset,
    },
    {
      id: "strict_superset",
      text: "Strict superset",
      latex: "\\supset",
      variant: "plain-subtle",
      icon: icons.StrictSuperset,
    },
    {
      id: "contains",
      text: "Contains",
      latex: "\\ni",
      variant: "plain-subtle",
      icon: icons.Contains,
    },
    {
      id: "left_half_open_interval",
      text: "Left half open interval",
      latex: "\\left\\lparen #0,\\placeholder{}\\right]",
      variant: "plain-subtle",
      icon: icons.LeftHalfOpenInterval,
    },
    {
      id: "right_half_open_interval",
      text: "Right half open interval",
      latex: "\\left\\lbrack #0,\\placeholder{}\\right)",
      variant: "plain-subtle",
      icon: icons.RightHalfOpenInterval,
    },
    {
      id: "not_element_of",
      text: "Not element of",
      latex: "\\notin",
      variant: "plain-subtle",
      icon: icons.NotAElementOf,
    },
    {
      id: "element_of",
      text: "Element of",
      latex: "\\in",
      variant: "plain-subtle",
      icon: icons.ElementOf,
    },

    {
      id: "hermitian_conjugate",
      text: "Hermitian conjugate",
      latex: "{\\placeholder}^H",
      variant: "plain-subtle",
      icon: icons.HermitianConjugate,
    },
    {
      id: "transpose",
      text: "Transpose",
      latex: "{\\placeholder}^T",
      variant: "plain-subtle",
      icon: icons.Transpose,
    },
    {
      id: "real_number",
      text: "Real_number",
      latex: "\\mathbf{R}",
      variant: "plain-subtle",
      icon: icons.RealNumber,
    },

    // ! GREEK nodeChildren

    {
      id: "alpha",
      text: "Alpha",
      latex: "\\alpha",
      variant: "plain-subtle",
      icon: icons.Alpha,
      shiftLatex: "\\Alpha",
      shiftIcon: icons.CapitalAlpha,
    },
    {
      id: "beta",
      text: "Beta",
      latex: "\\beta",
      variant: "plain-subtle",
      icon: icons.Beta,
      shiftLatex: "\\Beta",
      shiftIcon: icons.CapitalBeta,
    },
    {
      id: "gamma",
      text: "Gamma",
      latex: "\\gamma",
      variant: "plain-subtle",
      icon: icons.Gamma,
      shiftLatex: "\\Gamma",
      shiftIcon: icons.CapitalGamma,
    },
    {
      id: "delta",
      text: "Delta",
      latex: "\\delta",
      variant: "plain-subtle",
      icon: icons.Delta,
      shiftLatex: "\\Delta",
      shiftIcon: icons.CapitalDelta,
    },
    {
      id: "epsilon",
      text: "Epsilon",
      latex: "\\epsilon",
      variant: "plain-subtle",
      icon: icons.Epsilon,
      shiftLatex: "\\Epsilon",
      shiftIcon: icons.CapitalEpsilon,
    },
    {
      id: "Zeta",
      text: "Zeta",
      latex: "\\zeta",
      variant: "plain-subtle",
      icon: icons.Zeta,
      shiftLatex: "\\Zeta",
      shiftIcon: icons.CapitalZeta,
    },
    {
      id: "eta",
      text: "Eta",
      latex: "\\eta",
      variant: "plain-subtle",
      icon: icons.Eta,
      shiftLatex: "\\Eta",
      shiftIcon: icons.CapitalEta,
    },
    {
      id: "iota",
      text: "Iota",
      latex: "\\iota",
      variant: "plain-subtle",
      icon: icons.Iota,
      shiftLatex: "\\Iota",
      shiftIcon: icons.CapitalIota,
    },
    {
      id: "Kappa",
      text: "Kappa",
      latex: "\\kappa",
      variant: "plain-subtle",
      icon: icons.Kappa,
      shiftLatex: "\\Kappa",
      shiftIcon: icons.CapitalKappa,
    },
    {
      id: "Lambda",
      text: "Lambda",
      latex: "\\lambda",
      variant: "plain-subtle",
      icon: icons.Lambda,
      shiftLatex: "\\Lambda",
      shiftIcon: icons.CapitalLambda,
    },
    {
      id: "mu",
      text: "Mu",
      latex: "\\mu",
      variant: "plain-subtle",
      icon: icons.Mu,
      shiftLatex: "\\Mu",
      shiftIcon: icons.CapitalMu,
    },
    {
      id: "nu",
      text: "Nu",
      latex: "\\nu",
      variant: "plain-subtle",
      icon: icons.Nu,
      shiftLatex: "\\Nu",
      shiftIcon: icons.CapitalNu,
    },
    {
      id: "xi",
      text: "Xi",
      latex: "\\xi",
      variant: "plain-subtle",
      icon: icons.Xi,
      shiftLatex: "\\Xi",
      shiftIcon: icons.CapitalXi,
    },
    {
      id: "rho",
      text: "Rho",
      latex: "\\rho",
      variant: "plain-subtle",
      icon: icons.Rho,
      shiftLatex: "\\Rho",
      shiftIcon: icons.CapitalRho,
    },
    {
      id: "shift",
      text: "Shift Key",
      variant: "plain-default",
      icon: icons.ShiftOutlined,
      shiftIcon: icons.ShiftFill,
      onClick: (mfe, toggleShiftState) => {
        toggleShiftState();
      },
    },
    {
      id: "tau",
      text: "Tau",
      latex: "\\tau",
      variant: "plain-subtle",
      icon: icons.Tau,
      shiftLatex: "\\Tau",
      shiftIcon: icons.CapitalTau,
    },
    {
      id: "Upsilon",
      text: "Upsilon",
      latex: "\\upsilon",
      variant: "plain-subtle",
      icon: icons.Upsilon,
      shiftLatex: "\\Upsilon",
      shiftIcon: icons.CapitalUpsilon,
    },
    {
      id: "Phi",
      text: "Phi",
      latex: "\\phi",
      variant: "plain-subtle",
      icon: icons.Phi,
      shiftLatex: "\\Phi",
      shiftIcon: icons.CapitalPhi,
    },
    {
      id: "Chi",
      text: "Chi",
      latex: "\\chi",
      variant: "plain-subtle",
      icon: icons.Chi,
      shiftLatex: "\\Chi",
      shiftIcon: icons.CapitalChi,
    },
    {
      id: "Psi",
      text: "Psi",
      latex: "\\psi",
      variant: "plain-subtle",
      icon: icons.Psi,
      shiftLatex: "\\Psi",
      shiftIcon: icons.CapitalPsi,
    },
    {
      id: "Omega",
      text: "Omega",
      latex: "\\omega",
      variant: "plain-subtle",
      icon: icons.Omega,
      shiftLatex: "\\Omega",
      shiftIcon: icons.CapitalOmega,
    },
    {
      id: "Sigma",
      text: "Sigma",
      latex: "\\sigma",
      variant: "plain-subtle",
      icon: icons.Sigma,
      shiftLatex: "\\Sigma",
      shiftIcon: icons.CapitalSigma,
    },

    {
      id: "q",
      latex: "q",
      variant: "plain-subtle",
      icon: icons.AlphabetQ,
      shiftLatex: "Q",
      shiftIcon: icons.CapitalQ,
    },
    {
      id: "w",
      latex: "w",
      variant: "plain-subtle",
      icon: icons.AlphabetW,
      shiftLatex: "W",
      shiftIcon: icons.CapitalW,
    },
    {
      id: "E",
      latex: "e",
      variant: "plain-subtle",
      icon: icons.AlphabetE,
      shiftLatex: "E",
      shiftIcon: icons.CapitalE,
    },
    {
      id: "r",
      latex: "r",
      variant: "plain-subtle",
      icon: icons.AlphabetR,
      shiftLatex: "R",
      shiftIcon: icons.CapitalR,
    },
    {
      id: "t",
      latex: "t",
      variant: "plain-subtle",
      icon: icons.AlphabetT,
      shiftLatex: "T",
      shiftIcon: icons.CapitalT,
    },
    {
      id: "y",
      latex: "y",
      variant: "plain-subtle",
      icon: icons.AlphabetY,
      shiftLatex: "Y",
      shiftIcon: icons.CapitalY,
    },
    {
      id: "u",
      latex: "u",
      variant: "plain-subtle",
      icon: icons.AlphabetU,
      shiftLatex: "U",
      shiftIcon: icons.CapitalU,
    },
    {
      id: "i",
      latex: "i",
      variant: "plain-subtle",
      icon: icons.AlphabetI,
      shiftLatex: "I",
      shiftIcon: icons.CapitalI,
    },
    {
      id: "o",
      latex: "o",
      variant: "plain-subtle",
      icon: icons.AlphabetO,
      shiftLatex: "O",
      shiftIcon: icons.CapitalO,
    },
    {
      id: "p",
      latex: "p",
      variant: "plain-subtle",
      icon: icons.AlphabetP,
      shiftLatex: "P",
      shiftIcon: icons.CapitalP,
    },
    {
      id: "a",
      latex: "a",
      variant: "plain-subtle",
      icon: icons.AlphabetA,
      shiftLatex: "A",
      shiftIcon: icons.CapitalA,
    },
    {
      id: "s",
      latex: "s",
      variant: "plain-subtle",
      icon: icons.AlphabetS,
      shiftLatex: "S",
      shiftIcon: icons.CapitalS,
    },
    {
      id: "d",
      latex: "d",
      variant: "plain-subtle",
      icon: icons.AlphabetD,
      shiftLatex: "D",
      shiftIcon: icons.CapitalD,
    },
    {
      id: "f",
      latex: "f",
      variant: "plain-subtle",
      icon: icons.AlphabetF,
      shiftLatex: "F",
      shiftIcon: icons.CapitalF,
    },
    {
      id: "g",
      latex: "g",
      variant: "plain-subtle",
      icon: icons.AlphabetG,
      shiftLatex: "G",
      shiftIcon: icons.CapitalG,
    },
    {
      id: "h",
      latex: "h",
      variant: "plain-subtle",
      icon: icons.AlphabetH,
      shiftLatex: "H",
      shiftIcon: icons.CapitalH,
    },
    {
      id: "j",
      latex: "j",
      variant: "plain-subtle",
      icon: icons.AlphabetJ,
      shiftLatex: "J",
      shiftIcon: icons.CapitalJ,
    },
    {
      id: "k",
      latex: "k",
      variant: "plain-subtle",
      icon: icons.AlphabetK,
      shiftLatex: "K",
      shiftIcon: icons.CapitalK,
    },
    {
      id: "l",
      latex: "l",
      variant: "plain-subtle",
      icon: icons.AlphabetL,
      shiftLatex: "L",
      shiftIcon: icons.CapitalL,
    },
    {
      id: "z",
      latex: "z",
      variant: "plain-subtle",
      icon: icons.AlphabetZ,
      shiftLatex: "Z",
      shiftIcon: icons.CapitalZ,
    },
    {
      id: "x",
      latex: "x",
      variant: "plain-subtle",
      icon: icons.AlphabetX,
      shiftLatex: "X",
      shiftIcon: icons.CapitalX,
    },
    {
      id: "c",
      latex: "c",
      variant: "plain-subtle",
      icon: icons.AlphabetC,
      shiftLatex: "C",
      shiftIcon: icons.CapitalC,
    },
    {
      id: "v",
      latex: "v",
      variant: "plain-subtle",
      icon: icons.AlphabetV,
      shiftLatex: "V",
      shiftIcon: icons.CapitalV,
    },
    {
      id: "b",
      latex: "b",
      variant: "plain-subtle",
      icon: icons.AlphabetB,
      shiftLatex: "B",
      shiftIcon: icons.CapitalB,
    },
    {
      id: "n",
      latex: "n",
      variant: "plain-subtle",
      icon: icons.AlphabetN,
      shiftLatex: "N",
      shiftIcon: icons.CapitalN,
    },
    {
      id: "m",
      latex: "m",
      variant: "plain-subtle",
      icon: icons.AlphabetM,
      shiftLatex: "M",
      shiftIcon: icons.CapitalM,
    },
  ],

  // these buttons will be present for all the tabs
  commonChildren: [
    {
      id: "plus",
      text: "Plus",
      latex: "+",
      variant: "plain-default",
      icon: icons.Addition,
    },
    {
      id: "1",
      latex: "1",
      variant: "plain-default",
      icon: icons.NumberOne,
    },
    {
      id: "2",
      latex: "2",
      variant: "plain-default",
      icon: icons.NumberTwo,
    },
    {
      id: "3",
      latex: "3",
      variant: "plain-default",
      icon: icons.NumberThree,
    },
    {
      id: "backspace",
      text: "Backspace",
      icon: icons.Clear,
      variant: "plain-default",
      onClick: mfe => mfe.executeCommand("deleteBackward"),
    },
    {
      id: "minus",
      text: "Minus",
      latex: "-",
      variant: "plain-default",
      icon: icons.Subtraction,
    },
    {
      id: "4",
      latex: "4",
      variant: "plain-default",
      icon: icons.NumberFour,
    },
    {
      id: "5",
      latex: "5",
      variant: "plain-default",
      icon: icons.NumberFive,
    },
    {
      id: "6",
      latex: "6",
      variant: "plain-default",
      icon: icons.NumberSix,
    },
    {
      id: "undo",
      text: "Undo",
      variant: "plain-default",
      icon: icons.ReplyArrow1,
      onClick: mfe => mfe.executeCommand("undo"),
    },
    {
      id: "multiply",
      text: "Multiply",
      latex: "\\times",
      variant: "plain-default",
      icon: icons.Multiplication,
    },
    {
      id: "7",
      latex: "7",
      variant: "plain-default",
      icon: icons.NumberSeven,
    },
    {
      id: "8",
      latex: "8",
      variant: "plain-default",
      icon: icons.NumberEight,
    },
    {
      id: "9",
      latex: "9",
      variant: "plain-default",
      icon: icons.NumberNine,
    },
    {
      id: "redo",
      text: "Redo",
      variant: "plain-default",
      icon: icons.ReplyArrow2,
      onClick: mfe => mfe.executeCommand("redo"),
    },

    {
      id: "divide",
      text: "Divide",
      latex: "\\div",
      variant: "plain-default",
      icon: icons.Division,
    },
    {
      id: "equals",
      text: "Equals",
      latex: "=",
      variant: "plain-default",
      icon: icons.Equal,
    },
    {
      id: "not_equals",
      text: "Not equals",
      latex: "\\neq",
      variant: "plain-default",
      icon: icons.NotEqualTo,
    },
    {
      id: "0",
      latex: "0",
      variant: "plain-default",
      icon: icons.NumberZero,
    },
    {
      id: "forwardSlash",
      text: "Divide",
      variant: "plain-default",
      icon: icons.ForwardSlash,
      latex: "/",
    },
    {
      id: "comma",
      text: "Comma",
      latex: ",",
      variant: "plain-default",
      icon: icons.Comma,
    },
    {
      id: "identity",
      text: "Identity",
      latex: "\\equiv",
      variant: "plain-default",
      icon: icons.Identity,
    },
    {
      id: "approx",
      text: "Approx",
      latex: "\\approx",
      variant: "plain-default",
      icon: icons.Approximation,
    },
    {
      id: "insert",
      text: "insert",
      variant: "progressive",
      style: {
        gridColumn: "span 2",
      },
    },
  ],
};
